import { render, staticRenderFns } from "./companyBehaviorDetail.vue?vue&type=template&id=28e142f8&scoped=true"
import script from "./companyBehaviorDetail.vue?vue&type=script&lang=js"
export * from "./companyBehaviorDetail.vue?vue&type=script&lang=js"
import style0 from "./companyBehaviorDetail.vue?vue&type=style&index=0&id=28e142f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e142f8",
  null
  
)

export default component.exports